import {
    Box,
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    Grid,
    SelectChangeEvent,
    Theme,
    Typography
} from "@mui/material";
import {
    Form,
    Formik,
    FormikProps
} from "formik";
import * as Yup from 'yup';
import { MandateCreation } from "../../redux-store/types/investorProfile";
import MFSelectField from "../formik/SelectField";
import {
    useRef,
    useState
} from "react";
import { MFTextField } from "../formik";
import { LoadingButton } from "@mui/lab";
import { useDispatch,} from "react-redux";
import { useHistory, useRouteMatch } from "react-router";
import { chequePayment } from "../../redux-store/actions/cart";
import {
    ChequepaymentResponseBody,
    GetOrderPreviewResponseBody,
    InitiatePaymentResponseBody
} from "../../redux-store/types/cart";
import { showError } from "../../redux-store/actions/auth";
import { SuccessIcon } from "../../assets/SvgIcons";
import { chequeRegex, vpaRegex } from "../../utils/regex";
import { TextDatePicker } from "../../components/onboarding/DatePickerWithTextFeild";
import { getFormattedISTDate } from "../../utils/date";
import { futureAge, todaysdate } from "../../utils/utilityFunctions";
import { reportDownload } from "../../components/Reports/report-utils";
import { useSnackbar } from "notistack";
import { DepositBank } from "../../utils/utilityFunctions";
import { CHEQUE_HDFC_BANK, CHEQUE_MESSAGE } from "../../utils/constant";
interface Values {
    bankAccount: {
        bankAccountNumber: string,
        bankName: string,
        ifscCode: string
    } | null,
    chequeNo: string,
    chequeDate: string,
    depositBank: string
    pickUpPoint?: string,
    cityName?: string
}

interface RouterStateData {
    token: string
    cartId: string
    login_token?: string
}

const initialValues: Values = {
    bankAccount: null,
    chequeNo: "",
    chequeDate: "",
    depositBank: "",
    pickUpPoint: "",
    cityName: ""
}

const validationSchema = Yup.object().shape({
    bankAccount: Yup
        .object()
        .nullable()
        .test(
            "bank-account-required",
            "Bank Account is required",
            function (value) { return !!value }
        ),
    chequeDate: Yup
        .string().nullable().test('chequeNo', (value, context) => {
            const fieldValue = value === undefined ? '' : value;
            const { path, createError, parent } = context;
            if (!fieldValue) {
                return createError({
                    message: "Cheque Date is Required",
                    path,
                });
            }
            if (futureAge(fieldValue || '')) {
                return createError({
                    message: 'Future date is not allowed',
                    path,
                });
            }
            return true;

        }),
    chequeNo: Yup.string().nullable().required("Cheque Number Is Required")
        .test('cheque-validation', (value, context) => {
            const fieldvalue = value === undefined || value === null ? '' : value;
            const { path, createError, parent } = context;
            if (fieldvalue.length !== 6) {
                return createError({
                    message: "Cheque number must be exactly 6 digits",
                    path,
                });
            }
            if (!chequeRegex.test(fieldvalue)) {
                return createError({
                    message: "Invalid Cheque Number",
                    path,
                });
            }

            return true;
        }),
    pickUpPoint: Yup.string().nullable().test('pickUpPoint', (value, context) => {
        const fieldvalue = value === undefined || value === null ? '' : value;
        const { path, createError, parent } = context;
        if (parent?.depositBank === CHEQUE_HDFC_BANK) {
            if (!fieldvalue) {
                return createError({
                    message: 'PickUpPoint Is Required',
                    path,
                });
            }

        }

        return true;
    }),
    cityName: Yup.string().nullable().test('cityName', (value, context) => {
        const fieldvalue = value === undefined || value === null ? '' : value;
        const { path, createError, parent } = context;
        if (parent?.depositBank === CHEQUE_HDFC_BANK) {
            if (!fieldvalue) {
                return createError({
                    message: 'CityName Is Required',
                    path,
                });
            }

        }

        return true;
    })
})

export default function Cheque({
    bankDetailsData,
    orderPreviewData
}: {
    bankDetailsData: MandateCreation[];
    orderPreviewData: { payable_amount: number, orderId: string, isIndividualPayment: boolean }
}): JSX.Element {
    const dispatch = useDispatch()
    const history = useHistory();
    const routerStateObj = history.location.state as RouterStateData
    const { url } = useRouteMatch();
    const { enqueueSnackbar } = useSnackbar();

    const formikRef = useRef<FormikProps<Values>>(null);

    const [isLoading, setLoading] = useState<boolean>(false)
    const [isDialogOpen, setDialogOpen] = useState<boolean>(false)
    const LOOPBACKURL = `${window.location.origin}/bsetrade`;
    const isIndividualPayment = orderPreviewData?.isIndividualPayment ?? false;

    const handleSubmit = async (values: Values) => {
        try {

            const payment = {
                cartId: routerStateObj?.cartId ?? "",
                token: routerStateObj?.token ?? "",
                chequeNo: values?.chequeNo ?? "",
                chequeDate: values?.chequeDate ?? "",
                paymentMode: "CHEQUE",
                accountNumber: values?.bankAccount?.bankAccountNumber ?? "",
                ifsc: values?.bankAccount?.ifscCode ?? "",
                isIndividualPayment,
                temporaryToken: routerStateObj?.login_token ?? "",
                depositBank: values?.depositBank ?? "",
                pickUpPoint:values?.depositBank === CHEQUE_HDFC_BANK ? values?.pickUpPoint ?? "" : "",
                cityName:values?.depositBank === CHEQUE_HDFC_BANK ? values?.cityName ?? "" : "",
                ...(isIndividualPayment && { bseOrderId: orderPreviewData?.orderId })
            }


            setLoading(true);

            const response = await (dispatch(chequePayment(payment)) as unknown as Promise<ChequepaymentResponseBody>);
            if (response && response.type) {
                enqueueSnackbar('File downloaded successfully.', {
                    variant: 'success',
                    autoHideDuration: 2000,
                });
                reportDownload(response as unknown as Blob, 'Cheque.pdf');
                setDialogOpen(true)
            } else {
                enqueueSnackbar('File download failed!.', {
                    variant: 'error',
                    autoHideDuration: 2000,
                });
            }
        } catch (e) {
            console.log('error', e);
        } finally {
            setLoading(false);
        }
    }

    const handleBankAccountChange = (event: SelectChangeEvent<unknown>) => {
        const bankDetailsObj = (bankDetailsData ?? []).find(obj => obj?.bankAccountNumber === event.target.value)

        formikRef?.current?.setFieldValue("bankAccount", bankDetailsObj)
    }

    const depositBankChange = (event: SelectChangeEvent<unknown>) => {
        const selectedBank = event.target.value as string;
        formikRef?.current?.setFieldValue("depositBank", selectedBank);
    }

    const handleDialogClose = () => {
        // history.replace('/investor-dashboard')
        setDialogOpen(false);
        history.replace({
            pathname: url,
            state: {
                ...routerStateObj,
                isPaymentDone: true
            }
        });
    }

    const handleNavigateToOrders = () => {
        // const previousPath = path.substring(0, path.lastIndexOf('/'));
        // history.push(previousPath);

        history.goBack();
    }
    const handleDateChange = (fieldName: string, selectedDate: any, setFieldValue: any) => {
        setFieldValue(fieldName, getFormattedISTDate(selectedDate), true);
    }

    return (
        <>
            <Formik
                innerRef={formikRef}
                initialValues={initialValues}
                onSubmit={handleSubmit}
                validationSchema={validationSchema}
            >
                {({ values, setFieldValue }) => (
                    <Form>
                        <Box>
                            <Grid
                                container
                                columnSpacing={3}
                                rowSpacing={2}
                                sx={{ marginTop: "20px" }}
                            >
                                <Grid item xs={12} lg={6}>
                                    <MFSelectField
                                        name="bankAccount"
                                        label="Bank Account *"
                                        items={(bankDetailsData ?? []).map((obj) => ({
                                            key: `${obj?.bankName ?? ""} - ${obj?.bankAccountNumber ?? ""}`,
                                            value: obj?.bankAccountNumber ?? "",
                                        }))}
                                        onChange={handleBankAccountChange}
                                        value={values?.bankAccount?.bankAccountNumber ?? ""}
                                        disabled={isLoading || !orderPreviewData?.payable_amount}
                                    />
                                </Grid>
                                <Grid item xs={12} lg={6}>
                                    <TextDatePicker
                                        name='chequeDate'
                                        label='Cheque Date( DD/MM/YYYY)*'
                                        placeholder=""
                                        maxDate={todaysdate()}
                                        customHandleChange={(selectedDate: any) => handleDateChange('chequeDate', selectedDate, setFieldValue)}
                                        disabled={isLoading || !orderPreviewData?.payable_amount}  
                                    />
                                </Grid>
                                <Grid item xs={12} lg={6}>
                                    <MFTextField
                                        name="chequeNo"
                                        label="Cheque Number*"
                                        placeholder=""
                                        value={values?.chequeNo ?? ""}
                                        disabled={isLoading || !orderPreviewData?.payable_amount}                                
                                    />
                                </Grid>
                                <Grid item xs={12} lg={6}>
                                    <MFSelectField
                                        name="depositBank"
                                        label="Deposit Bank*"
                                        items={(DepositBank ?? []).map((bank) => ({
                                            key: bank,
                                            value: bank,
                                        }))}
                                        onChange={depositBankChange}
                                        value={values?.depositBank ?? ""}
                                        disabled={isLoading || !orderPreviewData?.payable_amount}
                                    />
                                </Grid>  
                                {values?.depositBank == CHEQUE_HDFC_BANK &&                                
                                    <>
                                        <Grid item xs={12} lg={6}>
                                            <MFTextField
                                                name="pickUpPoint"
                                                label="Pickup Point*"
                                                placeholder=""
                                                value={values?.pickUpPoint ?? ""}
                                                disabled={isLoading || !orderPreviewData?.payable_amount}
                                            />
                                        </Grid>
                                        <Grid item xs={12} lg={6}>
                                            <MFTextField
                                                name="cityName"
                                                label="City Name*"
                                                placeholder=""
                                                value={values?.cityName ?? ""}
                                                disabled={isLoading || !orderPreviewData?.payable_amount}
                                            />
                                        </Grid>
                                    </>
                                }


                                <Grid item xs={4}>
                                    <LoadingButton
                                        type="submit"
                                        variant="contained"
                                        loading={isLoading}
                                        loadingPosition="center"
                                        disabled={!orderPreviewData?.payable_amount}
                                        sx={(theme: Theme) => ({
                                            ...theme.typography.body_500,
                                            fontWeight: 700,
                                            lineHeight: "22.5px",
                                            letterSpacing: "0.02px",
                                            color: theme.palette.textDark.primary,
                                            borderRadius: "10px",
                                            padding: "13px 56px",
                                            boxShadow: "none",
                                            backgroundColor: theme.palette.primary[500],
                                            width: "100%"
                                        })}
                                    >
                                        SUBMIT
                                    </LoadingButton>
                                </Grid>
                            </Grid>                 
                        </Box>
                    </Form>
                )}
            </Formik>
            <Dialog
                aria-labelledby="success-dialog"
                open={isDialogOpen}
                PaperProps={{
                    sx: (theme: Theme) => ({
                        maxWidth: '550px',
                        width: "100%",
                        borderRadius: "12px",
                        padding: "24px",
                        backgroundColor: theme.palette.common.white
                    }),
                }}
            >
                <DialogContent
                    sx={{
                        display: "flex",
                        flexDirection: "column",
                        justifyContent: "center",
                        alignItems: "center",
                        rowGap: "12px",
                        padding: "15px",
                        overflow: "hidden"
                    }}
                >
                    <SuccessIcon />
                    <Typography
                        variant="h2"
                        sx={(theme: Theme) => ({
                            lineHeight: "25px",
                            letterSpacing: "0.01px",
                            color: theme.palette.text.primary
                        })}
                    >
                        Success
                    </Typography>
                    <Typography
                        variant="subtitle_400"
                        sx={(theme: Theme) => ({
                            lineHeight: "25px",
                            letterSpacing: "0.02px",
                            color: theme.palette.text.secondary,
                            textAlign: "center",
                            paddingLeft: "10px",
                            paddingRight: "10px"
                        })}
                    >
                        {CHEQUE_MESSAGE}
                    </Typography>
                    <Typography
                        variant="body_500"
                        sx={(theme: Theme) => ({
                            lineHeight: "30px",
                            letterSpacing: "0.02px",
                            color: theme.palette.text.primary,
                            textAlign: "center",
                            paddingLeft: "10px",
                            paddingRight: "10px"
                        })}
                    >
                        You can close this tab.
                    </Typography>
                </DialogContent>
                <DialogActions
                    sx={{
                        padding: "0px",
                        marginTop: "40px",
                    }}
                >
                    <Button
                        fullWidth
                        variant="contained"
                        onClick={isIndividualPayment ? handleNavigateToOrders : handleDialogClose}
                        sx={(theme: Theme) => ({
                            ...theme.typography.body_500,
                            fontWeight: 600,
                            lineHeight: "20px",
                            color: theme.palette.common.white,
                            borderRadius: "4px",
                            padding: "13px 20px",
                            backgroundColor: theme.palette.primary[500]
                        })}
                    >
                        {isIndividualPayment ? 'Go to Orders' : 'Okay'}
                    </Button>
                </DialogActions>
            </Dialog>
        </>
    )
}
